// utils/activityMeta.js
// Shared display helpers for activity-log timelines (Leads, Deals, Site
// Visits, Tasks) — one source of truth for icon/label/color per action type,
// used by both the shared ActivityLogModal and any inline timeline (e.g. the
// Lead Details page).
import React from "react";
import { Plus, RefreshCw, Pencil, CheckCircle2, UserCheck, MessageSquare } from "lucide-react";

export const getActionMeta = (action) => {
  switch (action) {
    case "created":
      return { icon: <Plus size={13} />, cls: "act-created", label: "Created" };
    case "completed":
      return { icon: <CheckCircle2 size={13} />, cls: "act-created", label: "Completed" };
    case "status_changed":
      return { icon: <RefreshCw size={13} />, cls: "act-status", label: "Status changed" };
    case "assigned":
      return { icon: <UserCheck size={13} />, cls: "act-status", label: "Assigned" };
    case "note":
      return { icon: <MessageSquare size={13} />, cls: "act-note", label: "Note" };
    default:
      return { icon: <Pencil size={13} />, cls: "act-updated", label: "Updated" };
  }
};

export const formatActivityTime = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleString("en-IN", {
      day: "numeric", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch (e) {
    return String(d);
  }
};
